export const IdValueFromConst = (object, value) => {
    let objVal = object.find(el => el.name === value);
    return objVal ? objVal.id : null;
}

export const LabelValueFromConst = (object, id, defaultVal = '') => {
    let objVal = object.find(el => el.id === id);
    return objVal ? objVal.name : defaultVal;
}